"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fix_parent_1 = require("./fix$parent");
var funcParams_1 = require("./funcParams");
var schemaPath_1 = require("./schemaPath");
var cacheFuncs = {};
function validFunction(schema, validFunc, cache, debug) {
    if (cache === void 0) { cache = true; }
    var func = null;
    if (validFunc) {
        if (cache && !debug) {
            func = cacheFuncs['valid_' + validFunc];
            if (func !== undefined) {
                return func;
            }
        }
        var stext = fix_parent_1.default(validFunc);
        // let ftext = '';
        if (stext.indexOf('{') === -1) {
            stext = "$result=(" + stext + ")";
        }
        var ffunc = "var $value=$obj.$model;\r\nvar $result=null;\r\n" + stext + ";";
        // ffunc+=`${}`;
        // ffunc += 'with($data) {';
        // ffunc += `with(parent) ${stext};`;
        // ffunc += '};';
        // ffunc += `console.log('validFuncResult','${propName}',$result);`;
        if (stext.indexOf('return ') === -1) {
            ffunc += '\r\nreturn $result;';
        }
        // ffunc += '\r\nreturn $result;';
        if (debug) {
            ffunc = "\r\n/*** debug only ***/\r\n\"" + schemaPath_1.default(schema, true) + "\"; // schema path\r\nconsole.debug($obj.$path); // model path\r\ndebugger;\r\n\r\n/*** function body ***/\r\n" + ffunc;
            // ffunc = 'console.debug($obj.$path);\r\ndebugger;\r\n' + ffunc;
        }
        // old
        /*
        ftext += `return (${stext});`;



        if (debug && !debug) {
            ftext = 'debugger;\r\n' + ftext;
        }
        */
        func = new Function(funcParams_1.default, ffunc);
        if (cache) {
            cacheFuncs['valid_' + validFunc] = func;
        }
    }
    return func;
}
exports.default = validFunction;
//# sourceMappingURL=validFunction.js.map